import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SubscriptionComponent from '../components/subscription.component';
import PageLoader from '../../../../components/PageLoader';
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectsubscriptionsQueryItems } from '../../../../redux/subscriptions/selector';
import { selectprogramsListItems } from '../../../../redux/programs/selector';
import { subscriptions } from '../../../../redux/subscriptions/action';
import { programs } from '../../../../redux/programs/action';



const DIGIITAISubscription= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectsubscriptionsQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
const [isQuery, setIsQuery] = useState<boolean>(false)
const programItems = useSelector(selectprogramsListItems)
const [selectedSubscriptions, setSelectedSubscriptions] = useState<any>({
  Email: '',
  PhoneNumber: '',
  Name: '',
  Description: '',
  ownerType: 'DBaasProgramPolicy',
  Amount: 0,
  Validity: ''
});

const [subscriptionInfo, setSubscriptionInfo] = useState<any>([])
  const fetchSubscriptionsById= ()=>{
    dispatch(subscriptions.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/query`,entity:'subscriptions',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedSubscriptions({ ...selectedSubscriptions, [field]: event });
  }

  useEffect(
    () => {
      dispatch(programs.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/programs/list`,entity:'programs',jsonData:{ 
        }})).then(()=>{
      if (parmas?.id > 0) {
        fetchSubscriptionsById()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    })},
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSubscriptionInfo(queryItems?.result?.items) 
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    const subscriptionData = {
      Email: selectedSubscriptions?.Email,
      PhoneNumber: selectedSubscriptions?.PhoneNumber,
      CallingCode: "+91",
      OwnerType: 'DBaasProgramPolicy',
      OwnerId: selectedSubscriptions?.OwnerId,
      Name: selectedSubscriptions?.Name,
      Description: selectedSubscriptions?.Description,
      Amount: selectedSubscriptions?.Amount,
      Validity: selectedSubscriptions?.Validity,
      BusinessName:selectedSubscriptions?.BusinessName,
      BusinessTypeId:selectedSubscriptions?.BusinessTypeId,
      IndustryTypeId:selectedSubscriptions?.IndustryTypeId,
      Address1:selectedSubscriptions?.Address1,
      Address2:selectedSubscriptions?.Address2,
      City:selectedSubscriptions?.City,
      CountryId:selectedSubscriptions?.CountryId,
      StateProvinceId:selectedSubscriptions?.StateProvinceId,
      ZipPostalCode:selectedSubscriptions?.ZipPostalCode,
      IsNewsLetterOpted: "true",
      IsTermsAccepted:"true"
    };

    if (parmas?.id > 0) {
      await dispatch(subscriptions.resetAction({ actionType: 'update' }))
      await dispatch(subscriptions.update({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions`,
        entity: 'subscriptions',
        jsonData: {
          Records: [subscriptionData]
        }
      })).then(() => {
        back();
      });
    } else {
      await dispatch(subscriptions.resetAction({ actionType: 'create' }))
      await dispatch(subscriptions.create({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions`,
        entity: 'subscriptions',
        jsonData: {
          Records: [subscriptionData]
        }
      })).then(() => {
        back();
      });
    }
  };
const back=()=>{
  navigate('/digiit-ai/subscriptions')
} 

    return (
    <>
      {isLoading ? <PageLoader /> : 
          <SubscriptionComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedSubscriptions={selectedSubscriptions}
           back={back}
           id={parmas?.id}
           handleFormSubmit={handleFormSubmit}
           programs={programItems?.result?.items}
           subscriptionInfo={subscriptionInfo}
          />  
    }
          </>
    )
    
    }
   
    export default DIGIITAISubscription;
